import r from "./index49.js";
import u from "./index63.js";
const f = "[REDACTED ****]";
function l(_) {
  if (r.hasOwnProp(_, "toJSON"))
    return !0;
  let e = Object.getPrototypeOf(_);
  for (; e && e !== Object.prototype; ) {
    if (r.hasOwnProp(e, "toJSON"))
      return !0;
    e = Object.getPrototypeOf(e);
  }
  return !1;
}
function c(_, e) {
  const s = new Set(e.map((t) => String(t).toLowerCase())), E = [], R = (t) => {
    if (t === null || typeof t != "object" || r.isBuffer(t))
      return t;
    if (E.indexOf(t) !== -1)
      return;
    t instanceof u && (t = t.toJSON()), E.push(t);
    let a;
    if (r.isArray(t))
      a = [], t.forEach((n, O) => {
        const o = R(n);
        r.isUndefined(o) || (a[O] = o);
      });
    else {
      if (!r.isPlainObject(t) && l(t))
        return E.pop(), t;
      a = /* @__PURE__ */ Object.create(null);
      for (const [n, O] of Object.entries(t)) {
        const o = s.has(n.toLowerCase()) ? f : R(O);
        r.isUndefined(o) || (a[n] = o);
      }
    }
    return E.pop(), a;
  };
  return R(_);
}
class i extends Error {
  static from(e, s, E, R, t, a) {
    const n = new i(e.message, s || e.code, E, R, t);
    return Object.defineProperty(n, "cause", {
      __proto__: null,
      value: e,
      writable: !0,
      enumerable: !1,
      configurable: !0
    }), n.name = e.name, e.status != null && n.status == null && (n.status = e.status), a && Object.assign(n, a), n;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(e, s, E, R, t) {
    super(e), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: e,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, s && (this.code = s), E && (this.config = E), R && (this.request = R), t && (this.response = t, this.status = t.status);
  }
  toJSON() {
    const e = this.config, s = e && r.hasOwnProp(e, "redact") ? e.redact : void 0, E = r.isArray(s) && s.length > 0 ? c(e, s) : r.toJSONObject(e);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: E,
      code: this.code,
      status: this.status
    };
  }
}
i.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
i.ERR_BAD_OPTION = "ERR_BAD_OPTION";
i.ECONNABORTED = "ECONNABORTED";
i.ETIMEDOUT = "ETIMEDOUT";
i.ECONNREFUSED = "ECONNREFUSED";
i.ERR_NETWORK = "ERR_NETWORK";
i.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
i.ERR_DEPRECATED = "ERR_DEPRECATED";
i.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
i.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
i.ERR_CANCELED = "ERR_CANCELED";
i.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
i.ERR_INVALID_URL = "ERR_INVALID_URL";
i.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const A = i;
export {
  A as default
};
